import {connect} from 'react-redux';

import {makeMapDispatchToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {hideBannerAction} from '../../../../store/panels/app/banners/bannersActions';
import {HandoffErrorBannerState} from '../../../../store/panels/app/banners/bannersState';
import {HandoffErrorBanner} from './handoffErrorBanner';

/*
 * Props.
 */

interface HandoffErrorBannerContainerProps {
  state: HandoffErrorBannerState;
}

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps<HandoffErrorBannerContainerProps>()((props) => {
  const {state} = props;
  return {
    onDismissClick: () => hideBannerAction(state.uid),
  };
});

export const HandoffErrorBannerContainer = connect(null, mapDispatchToProps)(HandoffErrorBanner);
